import { deleteField, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

export const PRIVATE_PROFILE_DOC_ID = 'profile';
export const PRIVATE_PROFILE_FIELDS = [
  'email',
  'phone',
  'stripeConnectAccountId',
  'stripeConnectStatus',
  'stripeConnectDetailsSubmitted',
];

export function getPrivateProfileRef(userId) {
  return doc(db, 'users', userId, 'private', PRIVATE_PROFILE_DOC_ID);
}

export function splitPublicAndPrivateProfile(data = {}) {
  const publicData = { ...data };
  const privateData = {};

  PRIVATE_PROFILE_FIELDS.forEach((field) => {
    if (publicData[field] !== undefined) {
      privateData[field] = publicData[field];
      delete publicData[field];
    }
  });

  return { publicData, privateData };
}

export async function loadPrivateProfile(userId) {
  if (!userId) return {};
  const snap = await getDoc(getPrivateProfileRef(userId));
  return snap.exists() ? snap.data() : {};
}

export async function savePrivateProfile(userId, privateData = {}) {
  if (!userId) return;
  const payload = splitPublicAndPrivateProfile(privateData).privateData;
  if (!Object.keys(payload).length) return;

  await setDoc(
    getPrivateProfileRef(userId),
    {
      ...payload,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
}

export async function migratePrivateFieldsFromPublic(userId, publicData = {}) {
  if (!userId) return publicData;

  const existingPrivate = await loadPrivateProfile(userId);
  const { publicData: strippedPublic, privateData: legacyPrivate } =
    splitPublicAndPrivateProfile(publicData);

  const hasLegacyPrivateFields = Object.keys(legacyPrivate).length > 0;
  if (!hasLegacyPrivateFields) return strippedPublic;

  await setDoc(
    getPrivateProfileRef(userId),
    {
      ...existingPrivate,
      ...legacyPrivate,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );

  const publicUpdates = { updatedAt: new Date().toISOString() };
  PRIVATE_PROFILE_FIELDS.forEach((field) => {
    if (publicData[field] !== undefined) {
      publicUpdates[field] = deleteField();
    }
  });

  await updateDoc(doc(db, 'users', userId), publicUpdates);
  return strippedPublic;
}